export default "__VITE_ASSET__0713f373__"